import React, {
  useEffect,
  useState
} from 'react';
import { Button, IconClipboard, useToast } from '@veneer/core';
import ConnectAPI from '../../../../../services/api';
import Swal from 'sweetalert2';
import { numberFormatCommaTwoFraction } from './../../../../../common/js/utils/numberFormat';
import useDynamicRefs from 'use-dynamic-refs';
import { useTranslation } from 'react-i18next';
import { authenticationService } from '../../../../../services/context/AuthService';
import { Trans } from 'react-i18next';

const RedeemRequest = (props) => {
  const connectApi = new ConnectAPI();
  const { id, idChannel, idSerie, idSubregions } = props.match.params;
  const [redeemInfo, setRedeemInfo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [redeemItems, setRedeemItems] = useState([]);
  const [getRef, setRef] = useDynamicRefs();
  const [amountTotal, setAmountTotal] = useState(0);
  const [sumTotal, setSumTotal] = useState(0);
  const [balance, setBalance] = useState(0);
  const [ordersBalance, setOrdersBalance] = useState();
  const { t, i18n } = useTranslation();
  const [disableButton, setdisableButton] = useState(true);
  let endUserTemp = JSON.parse(localStorage.getItem('endUser'));
  let endUser = null;
  const { idRole } = authenticationService.currentUserValue;

  const [nextId, setNextId] = useState(0);
  const { addToast } = useToast();

  if (endUserTemp !== null && endUserTemp.idEndUser === id) {
    endUser = endUserTemp;
  }

  useEffect(() => {
    if ((sumTotal === 0 || (sumTotal != 0 && isLoading)) || ([1, 6, 8].findIndex(role => role == idRole) > -1)) {
      setdisableButton(true);
    } else {
      setdisableButton(false);
    }
  }, [isLoading, sumTotal]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      connectApi
        .get(
          'api/Channels/CompensationStatement/redeem/',
          {
            params: {
              endUserId: id,
              channelId: idChannel,
              series: idSerie,

            },
          },
          dataResponseLoad
        )
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          Swal.fire(
            'Error ' + error.response.status,
            error.response.data,
            'error'
          );
        });
    };

    const dataResponseLoad = (status, data) => {
      const { redeemResponse, redeemList, flagOrdersBalance } = data;
      redeemList.map((item) => {
        item.total = 0;
        item.amount = 0;
      });
      setBalance(redeemResponse.compensation);
      setRedeemItems(redeemList === undefined ? [] : redeemList);
      setRedeemInfo(redeemResponse);
      setOrdersBalance(flagOrdersBalance.length>0?flagOrdersBalance:[]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const countTotal = (row) => (event) => {
    let amountTemp = 0;
    let totalTemp = 0;
    const orderResult = redeemItems.map((item) => {
      let newItem = { ...item };
      if (row.idPart === newItem.idPart) {
        newItem.amount = parseInt(event.currentTarget.value); //parseInt(getRef(item.pn).current.value) || 0;
        if (newItem.amount > 0) {
          newItem.total = newItem.amount * newItem.price;
        }
        else {
          newItem.total = 0;
        }

      }
      amountTemp += newItem.amount;
      totalTemp += newItem.total;
      return newItem;
    });

    if (totalTemp > redeemInfo.compensation) {
      addToast({ id: nextId, type: 'warning', text: t('balanceExceeded'), timeout: 20 });
      setNextId(prev => prev + 1);
      return;
    }
    setRedeemItems(orderResult);
    setAmountTotal(amountTemp);
    setSumTotal(totalTemp);
    setBalance(redeemInfo.compensation - totalTemp);
  };
  const handleRedeemCompensation = (index) => {
    let pressType = '';
    let serie = idSerie;
    if(!ordersBalance.find(x => x[0].toString().toUpperCase()==id.toString().toUpperCase() && x[2]=="1")){
      if (balance > 1000) {
        addToast({ id: nextId, type: 'warning', text: t('remainingBalanceAlert'), timeout: 20 });
        setNextId(prev => prev + 1);
        return;
      }
    }

    const orderList = redeemItems
      .filter((item) => item.amount > 0)
      .map((item) => {
        pressType = item.pressClassification;
        return {
          productNumber: item.idPart,
          quantity: item.amount,
          clientAmount: item.price,
          channelAmount: item.compensationChannel,
          productDescription: item.description,
        };
      });
    setIsLoading(true);
    connectApi
      .post(
        'api/Channels/orders/',
        {
          orderList: orderList,
          endUserId: id,
          customerId: idChannel,
          pressType: pressType,
          serie: parseInt(serie),

        },
        dataResponseLoad
      )
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        console.log(error.response);
        if (error.response?.status == 403) {
          Swal.fire('Error ' + 403, 'Not authorized', 'error');
        }else if (error?.response?.data.includes('An order is in progress')) {
          addToast({ id: nextId, type: 'warning', text: t('orderInProgressAlert'), timeout: 20 });
          setNextId(prev => prev + 1);
        } else {
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        }
      });
  };

  const dataResponseLoad = (status, data) => {
    setIsLoading(false);
    const { history } = props;
    history.push({
      pathname: '/cpp/report/statement/order/' + data
    });
  };

  return redeemInfo == undefined ? (

    <div style={{
      paddingTop: '10px',
      position: 'fixed',
      zIndex: '4',
      width: '100%',
      backgroundColor: 'white',
      borderBottomStyle: 'solid',
      borderBottomColor: '#ebebeb',
      borderBottomWidth: 'thin'
    }}>
      <h5> {t('redeemCompensation')} </h5>
      <br />
      <p style={{ marginBottom: '10px' }}>{t('channel')} </p>
      <br />
    </div>
  ) : (
    <div>
      <div style={{
        paddingTop: '10px',
        position: 'fixed',
        zIndex: '4',
        width: '100%',
        backgroundColor: 'white',
        borderBottomStyle: 'solid',
        borderBottomColor: '#ebebeb',
        borderBottomWidth: 'thin'
      }}>
        <h4> {t('redeemCompensation')} - {endUser?.endUserName} </h4>
        <p style={{ marginBottom: '10px' }}>
          <b>{t('channel')}:</b> {endUser?.customerName}
        </p>
      </div>
      <br />
      <br />
      <br />

      {redeemInfo.active ? (
        ''
      ) : (
        <h5 className="text-danger">{t('orderInProgress')}</h5>
      )}
      <br />

      <div className="table-responsive">
        <table className="table table-striped table-hover table-bordered table-sm table-fit">
          <thead>
            <tr>
              <th scope="col" className="text-center">
                PN
              </th>
              <th scope="col" className="text-center">
                {t('supply')}
              </th>
              <th scope="col" className="text-center">
                {t('pressType')}
              </th>
              <th scope="col" className="text-center">
                {t('price')} (US$)
              </th>
              <th scope="col" className="text-center">
                {t('quantity')}
              </th>
              <th scope="col" className="text-center">
                Total (US$)
              </th>
            </tr>
          </thead>
          <tbody>
            {redeemItems.map((row, index) => {
              return (
                row.price<=0?(<></>):(
                <tr key={row.idPart}>
                  <td
                    className="align-middle"
                    align="left"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {row.idPart}
                  </td>
                  <td className="align-middle">{row.description}</td>
                  <td className="align-middle">{row.pressClassification}</td>
                  <td className="text-right align-middle">
                    {numberFormatCommaTwoFraction(row.price)}
                  </td>
                  <td className="text-right align-middle">
                    <input
                      disabled={!redeemInfo.active || idRole == 12}
                      min="0"
                      defaultValue="0"
                      className="form-control text-right"
                      type="number"
                      value={isNaN(row.amount) ? parseInt(0) : row.amount}
                      id={row.idPart + 'input'}
                      ref={setRef(row.idPart)}
                      onChange={countTotal(row)}
                    />
                  </td>
                  <td className="align-middle" align="right">
                    {numberFormatCommaTwoFraction(row.total === isNaN(row.total) ? parseInt(0) : row.total)}
                  </td>
                </tr>
              ));
            })}
            <tr>
              <th colSpan="4" scope="row" className="text-right">
                Total
              </th>
              <th className="text-right" scope="row">
                {isNaN(amountTotal) ? parseInt(0) : amountTotal}
              </th>
              <th className="text-right" scope="row">
                {numberFormatCommaTwoFraction(sumTotal)}
              </th>
            </tr>
            <tr>
              <th colSpan="5" scope="row" className="text-right">
                {t('balance')}
              </th>
              <th className="text-right" scope="row">
                {numberFormatCommaTwoFraction(balance)}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        {idRole == 12 ? undefined : (
          <Button
            onClick={() => handleRedeemCompensation()}
            disabled={disableButton}
            leadingIcon={<IconClipboard />}
            loading={isLoading}
          >
            <Trans i18nKey='redeem' />
          </Button>
        )}
      </div>
    </div>
  );
};

export default RedeemRequest;
